goog.provide('el8.util.workspace');

function strictIsInWorkspace(item){
    if (typeof item.isInWorkspace === "boolean"){
        return item.isInWorkspace;
    }
    if (typeof item._inWorkspace === "boolean"){
        return item._inWorkspace;
    }
    if (item.rawData &&
        typeof item.rawData.isInWorkspace === "boolean"){
        return item.rawData.isInWorkspace;
    }
    return undefined
}

function isInWorkspace(item){
    var inWorkspace = typeof item.isInWorkspace === "function" ? item.isInWorkspace() : strictIsInWorkspace(item);
    return inWorkspace === undefined || inWorkspace;
}

function id_mapper(item){
    return typeof item.getId === "function" ? item.getId() : item.id || item._id
}

/**
 *
 * @param {*} items an entity or an array of entities
 * @returns undefined if a model cannot be identified, otherwise a model name
 */
function extractModel(items){
    var model;
    var item = ! Array.isArray(items) ? items : items.length && items[0];
    if (item){
        model = item.model_class || item._model_class
        if(!model && item.rawData){
            model = item.rawData.model_class || item.rawData._model_class
        }
        // Originally attempted before item.model_class, now used last instead
        //   of first because elation south & other test data has noncompliant ids
        if(!model){
            model = el8.model.idToModelClass(id_mapper(item));
        }
    }
    return model
}

el8.util.workspace = (function() {
    var that = this;

    that._stashes = {};

    that.isInEffect = function(){
        return (
            el8Globals.FEATURES.MoreWorkspaceFilters
            && el8Globals.WORKSPACE
            && el8Globals.WORKSPACE.filter_provider_accounts
        )
    }

    /**
     * This creates a stash to safely store workspace info away from where workspace-ignorant
     *   code might be modifying models after they're loaded.
     *
     * @param {*} items an array of entities containing a model class with an isInWorkspace() getter
     */
    that._fillStash = function (items){
        var model = extractModel(items);
        if (model){
            if (that._stashes[model] === undefined){
                that._stashes[model] = {}
            }
            items
                .filter(isInWorkspace)
                .map(id_mapper)
                .forEach(function(id){
                    that._stashes[model][id]=true
                });
        } else {
            console.error("attempt to build workspace stash failed for:", items);
        }
    };

    /**
     * This takes a given data model that wants to be workspace aware, and if the relevant flags
     *   indicate it should happen then create and delete item events on the model will be given
     *   a chance to update workspace information -- but a chance only as not all times will the
     *   item passed to the event contain workspace data.
     */
    that.bindToDataModelUpdates = function(dataModel){
        // Search core/model/model.js for EVENTS and Function.prototype.addEvents for more
        dataModel.bind('created', function (){
            that._fillStash(dataModel.all())
        });
        dataModel.bind('loaded', function (){
            that._fillStash(dataModel.all())
        });
        dataModel.bind('deleted', function (item){
            var dropId = id_mapper(item);
            var model = extractModel(item);
            if(model && dropId && that._stashes[model][dropId]){
                delete that._stashes[model][dropId]
            }
        });
    }

    that.workspaceFilter = function(item) {
        var id = id_mapper(item);
        var model = extractModel(item);
        return (that._stashes[model]) ? // Whenever possible use the result of fillStash
            that._stashes[model][id] :
            // A 'fail gracefully' that can work sometimes, but at other times
            //  changed base objects caused a loss of workspace info and "adds"
            //  items to the workspace because the default is to show items. It
            //  will at least include what is in the workspace, unfortunately
            //  sometimes it will include more.
            isInWorkspace(item)
    }

    that.filteringWrapper = function(wrapped_fn){
        if (!that.isInEffect()){
            /***
             * Outside of workspaces that filter, we regularly want things that simply act
             * like the original functions.
             */
            return wrapped_fn
        }
        /***
         *  Replace wrapped_fn with a function that will filter arrays with filter_fn
         *
         *  NOTE: _args is here just to make it clear you can use this with functions
         *   that take arguments. Since this is legacy, however, rest parameters don't
         *   work and we have to revert to the array-like function prototype property
         *   of "arguments" and since the spread operator also doesn't work we have to
         *   apply the array to a call of the wrapped function with a different method.
         */
        return function (_args){
            // the following is old school for "unfiltered = wrapped_fn(...args)"
            var unfiltered = wrapped_fn.apply(void 0, arguments);
            if (Array.isArray(unfiltered)){
                return unfiltered.filter(that.workspaceFilter)
            }
            return unfiltered
        }
    };

    return that;

})();
